import axios from "axios";
import config from '../../config'
// const BASE_URL = "http://3.22.188.65:8080"
const BASE_URL = config.apiUrl





  // const UpdateAccount = async (Data,Token) => {
  //   const options = {
  //     baseURL: BASE_URL,
  //     responseType: 'json',
  //     headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         'Access-Control-Allow-Origin':"*/*",
  //         'Authorization': `Bearer ${Token}`
  //     },
  // }
  
  // const instance = axios.create(options)
  //   try {
  //     const response = await instance.post("/account/Updateaccount",Data); 
  //     return response.data;
  //   } catch (error) {
  //     throw error;
  //   }
  // };



  const AuthLogin = async (email, password) => {
    const Data = {
      "login" : email,
      "password": password
    }
    const options = {
      baseURL: BASE_URL,
      responseType: 'json',
      headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          'Access-Control-Allow-Origin':"*/*",
      },
  }
  
  const instance = axios.create(options)
    try {
      const response = await instance.post("/rabat-zoo/utilisateur/api/authentification",Data); 
      return response;
    } catch (error) {
      throw error;
    }
  };


  const AuthSignup = async (fullname,email, password,role) => {
    const Data = {
      "email" : email,
      "password": password,
      "fullname": fullname,
      "role": role
    }
    console.log(Data)
    const options = {
      baseURL: BASE_URL,
      responseType: 'json',
      headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          'Access-Control-Allow-Origin':"*/*",
      },
  }
  
  const instance = axios.create(options)
    try {
      const response = await instance.post("/api/auth/signup",Data); 
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const GetDashboard = async (Token) => {
    const options = {
      baseURL: BASE_URL,
      responseType: 'json',
      headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          'Access-Control-Allow-Origin':"*/*",
          'Authorization': `Bearer ${Token}`
      },
    }
    const instance = axios.create(options)
    try {
      const response = await instance.get("/api/dashboard/GetDashboard"); 
      return response.data;
    } catch (error) { 
        throw error.response 
    }

  }

  const GetlisteUsers = async () =>{
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }
  
    const instance = axios.create(options)
      try {
        const response = await instance.get("/rabat-zoo/utilisateur/api/getListUtilisateurAdmins" ); 
        return response.data;
      } catch (error) { 
          throw error.response 
      }
}

const CreateUser = async (DataPost) => {
  const options = {
    baseURL: BASE_URL,
    responseType: 'json',
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        'Access-Control-Allow-Origin':"*/*",
        // 'Authorization': `Bearer ${Token}`
    },
}

const instance = axios.create(options)
  try {
    const response = await instance.post("/rabat-zoo/utilisateur/api/add",DataPost); 
    return response.data;
  } catch (error) { 
    throw error.response 
}
};

const UpdateRoleUser = async (DataPost) => {
  const options = {
    baseURL: BASE_URL,
    responseType: 'json',
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        'Access-Control-Allow-Origin':"*/*",
        // 'Authorization': `Bearer ${Token}`
    },
}

const instance = axios.create(options)
  try {
    const response = await instance.put("/rabat-zoo/utilisateur/api/update",DataPost); 
    return response.data;
  } catch (error) { 
    throw error.response 
}
};







  

  export {AuthLogin,AuthSignup,GetDashboard,GetlisteUsers,CreateUser,UpdateRoleUser};